import React, { Component } from 'react';
import './App.css';
import ComponentRow from './panel/ComponentRow';

class PanelComponents extends Component {
	
	constructor(props) {
		super(props);
		
		this.handleCheck = this.handleCheck.bind(this);
	}
	
	handleCheck(e) {
		if( this.props.setDirty ){
			this.props.setDirty(true);
		}
		var selectedComponents = this.props.selectedComponents.slice();
		var checkedComponent = this.props.components.find((component) => {
			return component.id.toString() === e.currentTarget.value;
		});
		
		if (e.currentTarget.checked) {
			// Remove any selected component that does not belong to this component's parent profile
			if (this.props.profile) {
				let allComponentIds = this.props.getProfileComponentIds([this.props.profile]);
				selectedComponents = selectedComponents.filter(component => allComponentIds.indexOf(component) > -1);
			}

			// add the selected component and all child components if checking a box
			selectedComponents.push(checkedComponent.id.toString());
			selectedComponents = selectedComponents.concat(this.props.getProfileComponentIds(checkedComponent.profileComponents));

		} else {
			// otherwise, remove the component and all child components
			selectedComponents = selectedComponents.filter((reqComponentId) => {
				var componentIds = [checkedComponent.id.toString()].concat(this.props.getProfileComponentIds(checkedComponent.profileComponents));
				return componentIds.indexOf(reqComponentId) === -1;
			});
		}
		
		this.props.setSelectedComponents(selectedComponents);
	}
	
	render() {
		if (!this.props.components || !this.props.components.length) {
			return null;
		}
		const displayCheckbox = typeof this.props.setSelectedComponents !== 'undefined';

		let nameColumnWidth = this.props.showCptQuantity ? '6' : '8';
		let cptColumnWidth = this.props.showCptQuantity ? '3' : '3';
		return (
			<div className="components">
				{this.props.showHeader && (
					<div className="row" style={{ marginBottom: '5px' }}>
						<div className={'col-xs-' + nameColumnWidth}>
							<span style={{ textDecoration: 'underline black solid 1px' }}>
								<b>Profile components</b>
							</span>
						</div>
						<div className={'col-xs-' + cptColumnWidth}>
							<span style={{ textDecoration: 'underline black solid 1px' }}>
								<b>CPT Codes</b>
							</span>
						</div>
						{this.props.showCptQuantity && (
							<div className="col-xs-2 padding-x-0">
								<span style={{ textDecoration: 'underline black solid 1px' }}>{this.props.splitCptQty ? 'Qty' : 'Other/MC'}</span>
								{(!this.props.disabled && this.props.isMedicareOrder && this.props.setEditingCptQuantity && this.props.updateCptQuantity) && (
									<button type="button" title="Update Billable CPT Quantity" className="btn-link btn-unstyled" onClick={this.props.setEditingCptQuantity}>
										<i className="fa fa-pencil-square-o padding-x-xs"></i>
									</button>
								)}
							</div>
						)}
					</div>
				)}
				{this.props.components.map(
					function (listValue) {
						let checked = this.props.selectedComponents.indexOf(listValue.id.toString()) !== -1;
						let panelSelected = (this.props.selectedPanel === listValue.parentId.toString()) && !this.props.profile?.displayOnly;
						return (
							<div className="profile-component" key={listValue.id}>
								<ComponentRow
									inputFieldType="component"
									nameColumnWidth={nameColumnWidth}
									cptColumnWidth={cptColumnWidth}
									displayCheckbox={displayCheckbox}
									inputField={listValue}
									disabled={this.props.disabled}
									checked={(checked)}
									handleCheck={this.handleCheck}
									isMedicareOrder={this.props.isMedicareOrder}
									parentChecked={panelSelected}
									showCptQuantity={this.props.showCptQuantity}
									cptQuantityMap={this.props.cptQuantityMap}
									splitCptQty={this.props.splitCptQty}
									disableCptQtyUpdate={this.props.disableCptQtyUpdate}
									isEditingCptQuantity={this.props.isEditingCptQuantity}
									updateCptQuantity={this.props.updateCptQuantity}
									priceMap={this.props.priceMap}
									priceDisplayType={this.props.priceDisplayType}
								/>

								<PanelComponents
									components={listValue.profileComponents}
									setDirty={this.props.setDirty}
									disabled={this.props.disabled || checked}
									selectedPanelId={this.props.selectedPanelId}
									getProfileComponentIds={this.props.getProfileComponentIds}
									selectedComponents={this.props.selectedComponents}
									setSelectedComponents={this.props.setSelectedComponents}
									selectedPanel={this.props.selectedPanel}
									showCptQuantity={this.props.showCptQuantity}
									splitCptQty={this.props.splitCptQty}
									isMedicareOrder={this.props.isMedicareOrder}
									profile={this.props.profile}
									updateCptQuantity={this.props.updateCptQuantity}
									cptQuantityMap={this.props.cptQuantityMap}
									isEditingCptQuantity={this.props.isEditingCptQuantity}
									setEditingCptQuantity={this.props.setEditingCptQuantity}
									disableCptQtyUpdate={this.props.disabled}
								/>
							</div>
						);
					}.bind(this)
				)}
			</div>
		);
	}
}

export default PanelComponents;
